<template>
    <div>
    <section class="mt-3 py-3" id="padre">
        <h4 class="mb-4">Tablas</h4>
        <p class="text-dark my-0"> Tabla básica</p>
    
        <div class="mb-3">
            <vs-table striped>
                <template #thead class="_header">
                    <vs-tr class="header_table">
                        <vs-th> Name </vs-th>
                        <vs-th> Email </vs-th>
                        <vs-th> Id </vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr :key="i" v-for="(tr, i) in users" :data="tr">
                        <vs-td> {{ tr.name }} </vs-td>
                        <vs-td> {{ tr.email }} </vs-td>
                        <vs-td> {{ tr.id }} </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <!-- collapse -->
        <div class="accordion" id="accordionExample">
            <div class="accordion-item body-3 montserrat-400">
                <h2 class="accordion-header" id="headingTwo">
                    <button 
                        class="accordion-button surface collapsed body-2 montserrat-400" 
                        type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" 
                        aria-expanded="false" aria-controls="collapseTwo"> Mostrar codigo
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" 
                    aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                    <p class="mb-0 pt-2 ps-5 bg-light border-bottom">Codigo html</p>
                    <div v-highlight>
                    <pre class="language-html p-0 m-0"><code><script type="text/plain" class="language-markup">
            <vs-table striped>
                <template #thead class="_header">
                    <vs-tr class="header_table">
                        <vs-th> Name </vs-th>
                        <vs-th> Email </vs-th>
                        <vs-th> Id </vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr :key="i" v-for="(tr, i) in users" :data="tr">
                        <vs-td> { { tr.name }} </vs-td>
                        <vs-td> { { tr.email }} </vs-td>
                        <vs-td> { { tr.id }} </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            </script></code></pre>
        </div>

        <p class="mb-0 pt-2 ps-5 bg-light border-bottom border-top">Codigo Javascript: Ejemplo de lista.</p>
            <div v-highlight>
            <!-- <p class="text-dark my-0">Ejemplo de codigo para tabla básica</p> -->
            <pre class="language-javascript"><code>
            export default {
            data: function() {
                return{
                    selected: null,
                    users: [
                        {
                            "id": 1,
                            "name": "Leanne Graham",
                            "username": "Bret",
                            "email": "Sincere@april.biz",
                            "website": "hildegard.org",
                        },
                        {
                            "id": 2,
                            "name": "Ervin Howell",
                            "username": "Antonette",
                            "email": "Shanna@melissa.tv",
                            "website": "anastasia.net",
                        }
                    ]
                }
            }   </code></pre>
                        </div>
                        <!--  -->
                    </div>
                </div>
            </div>
        </div>

        <!-- collapse fin -->


    </section>


    <section class="mt-3 py-3">
        <h5 class="text-dark mt-0 mb-3"> Tabla con filtros</h5>
        <div>
            <px-table 
                :dataRows="dataRows" 
                :dataColumns="dataColumns" 
                :selected="selected"
                :checkAllRows="true"
                :expand="true"
                :maxNumber=10
                :showSearch="true"
                @table-sort="handleSortTable"
                @select-all="handleSelectAllTable"
            >
            <template v-slot:cell="{value,type,property}">
                <template v-if="type == 'status'">
                    <px-badge 
                        :dataConfiguration="badgeConfiguration" 
                        :value="value.idestatus"
                        :description="value.desc_estatus"
                    >
                    </px-badge>
                </template>
                <template v-else-if="type == 'actions'">
                    <div class="btn-group dropstart">
                        <button
                            class="btn-transparent text-primary-variant dropdown-toggle" 
                            type="button"
                            id="dropdown"
                            data-bs-toggle="dropdown" 
                            aria-expanded="false"
                        >
                        <i class="fa-solid fa-gear text-primary-sh"></i>
                        <!-- <px-icon img="cancelar" color="#E04167" /> -->
                        </button>
                        <ul class="dropdown-menu">
                            <li><button class="dropdown-item" type="button">Opcion #1</button></li>
                            <li><button class="dropdown-item" type="button">Opcion #2</button></li>
                        </ul>
                    </div>
                    </template>
                    <template v-else>{{value[property]}}</template>
                </template>
                <template v-slot:expand="{value}">
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                            <span>name: {{value.name}}</span>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                            <span>username: {{value.username}}</span>
                        </vs-col>
                    </vs-row>
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                            <span>email: {{value.email}}</span>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                            <span>website: {{value.website}}</span>
                        </vs-col>
                    </vs-row>
                </template>
            </px-table>
        </div>

        <!-- aqui comienza el desastre de ver como ordeno la configuracion de la tabla -->
        <!-- <p class="mb-0 mt-3">Para el uso de esta tabla se deben importar estos 2 archivos, de la siguiente forma</p> -->

        <p class="text-dark mt-4 mb-1">Para el uso de esta tabla se deben importar estos 2 archivos, de la siguiente forma</p>
        <div v-highlight>
    <pre class="language-javascript"><code>
        import PxTable from '@/components/table/PxTable.vue'
        import PxBadge from '@/components/badge/PxBadge.vue'

        components:{PxTable,PxBadge} 
        </code></pre>
        </div>

    <p class="mb-0 mt-3">Metodos <u>obligatorios</u> para el manejo de filtros.</p>
    <div v-highlight>
    <pre class="language-javascript"><code>
        methods:{
            handleSortTable($event, columnProperty){
                this.dataRows = this.$vs.sortData($event ,this.dataRows , columnProperty)
            },
            handleSelectAllTable(){
                this.selected = this.$vs.checkAll(this.selected, this.dataRows)
            }
        }
        </code></pre>
    </div>


        <!-- codigo de tabla completa en el textarea -->
        <p class="mb-0 mt-3">Añadir componente tabla con filtros. <br> <span class="badge rounded-pill text-bg-info">New</span> Clase <code>.small_table</code> para hacer filas y columnas mas pequeñas.</p> 
        <div v-highlight>
    <pre class="language-html"><code><script type="text/plain" class="language-markup">
    <px-table 
        class="small_table"
        :dataRows="dataRows" 
        :dataColumns="dataColumns" 
        :selected="selected"
        :checkAllRows="true"
        :expand="true"
        :maxNumber="10"
        @table-sort="handleSortTable"
        @select-all="handleSelectAllTable"
    >
        <template v-slot:cell="{value,type,property}">
            <template v-if="type == 'status'">
                <px-badge 
                    :dataConfiguration="badgeConfiguration" 
                    :value="value.idestatus"
                    :description="value.desc_estatus"
                >
                </px-badge>
            </template>
            <template v-else-if="type == 'actions'">
                <div class="btn-group dropstart">
                    <button
                        class="btn-transparent text-primary-variant dropdown-toggle"
                        type="button"
                        id="dropdown"
                        data-bs-toggle="dropdown" 
                        aria-expanded="false"
                    >
                        <font-awesome-icon icon="fa-solid fa-gear" class="text-gray-medium" />
                    </button>
                    <ul class="dropdown-menu">
                        <li><button class="dropdown-item" type="button">Opcion #1</button></li>
                        <li><button class="dropdown-item" type="button">Opcion #2</button></li>
                    </ul>
                </div>
            </template>
            <template v-else>{ {value[property]}}</template>
        </template>
        <template v-slot:expand="{value}">
            <!-- aqui su codigo collapsado-->
            <p> --- Contenido collapsado --- </p>
            <center>{ {value}}</center>
        </template>
    </px-table></script></code></pre>
        </div>
        <!-- collapse -->
        <div class="accordion" id="json">
            <div class="accordion-item body-3 montserrat-400">
                <h2 class="accordion-header" id="json-2">
                    <button 
                        class="accordion-button surface collapsed body-2 montserrat-400" 
                        type="button" data-bs-toggle="collapse" data-bs-target="#jsonCollapse" 
                        aria-expanded="false" aria-controls="jsonCollapse"> Ver json de muestra para tabla
                    </button>
                </h2>
                <div id="jsonCollapse" class="accordion-collapse collapse" 
                    aria-labelledby="json-2" data-bs-parent="#json">
                    <div class="accordion-body p-0">
                    <p class="mb-0 pt-2 ps-5 bg-light border-bottom">Codigo Javascript</p>
                    <div v-highlight>
    <pre class="language-javascript p-0"><code>
        export default {
            data: function() {
                return{
                    selected:[],
                    dataRows: [
                        {
                        "id": 1,
                        "name": "Leanne Graham",
                        "username": "Bret",
                        "email": "Julianne.OConner@kory.org",
                        "website": "hildegard.org",
                        "idestatus": "1",
                        "desc_estatus":"Activo"
                        },
                        {
                        "id": 2,
                        "name": "Ervin Howell",
                        "username": "Antonette",
                        "email": "Julianne.OConner@kory.org",
                        "website": "anastasia.net",
                        "idestatus": "1",
                        "desc_estatus":"Activo"
                        }
                    ],
                    dataColumns: [
                        {
                            columnName:"Name",
                            columnProperty:"name",
                            type:"text",
                            filter:true,
                            sort:true,
                            rowsFilter:[],
                            width:10
                        },
                        {
                            columnName:"Email",
                            columnProperty:"email",
                            filter:true,
                            type:"text",
                            sort:false,
                            rowsFilter:[],
                            width:20
                        },
                        columnName:"Acciones",
                            columnProperty:"",
                            type:"actions",
                            filter:false,
                            sort:false,
                            rowsFilter:[],
                            width:10
                        }
                    ],
                    badgeConfiguration:[
                        {
                            value:1,
                            colorClass:"badge rounded-pill bg-sucess-sh text-white-sh"
                        },
                        {
                            value:2,
                            colorClass:"badge rounded-pill bg-warning-sh text-gray-medium"
                        },
                        {
                            value:3,
                            colorClass:"badge rounded-pill bg-danger-sh text-white-sh"
                        },
                    ]
                }
            }
        }</code></pre>
        </div>
                </div>
                </div>
            </div>
        </div>




            <p class="mb-0 mt-5">Propiedades que debe tener el componente tabla (px-table) para su funcionamiento</p>
            <table class="table" style="font-size:.8rem;">
                <thead>
                    <tr>
                    <th width="20%" scope="col">Propiedad</th>
                    <th scope="col">Atributo</th>
                    <th scope="col">Descripción</th>
                    </tr>
                </thead>
                <tbody class="table-group-divider">
                    <tr v-for="(desc, index) in descripcion" :key="index">
                    <th width="20%" scope="row"> <code>{{desc.propiedad}}</code> </th>
                    <td style="font-size:.7rem;">{{desc.atributo}}</td>
                    <td>{{desc.descripcion}}</td>
                    </tr>
                </tbody>
            </table>

            <p class="mb-0 mt-5">Propiedades que debe tener el componente badge (px-badge) para su funcionamiento</p>
            <table class="table" style="font-size:.8rem;">
                <thead>
                    <tr>
                    <th scope="col">Propiedad</th>
                    <th scope="col">Atributo</th>
                    <th scope="col">Descripción</th>
                    </tr>
                </thead>
                <tbody class="table-group-divider">
                    <tr v-for="(badge, index) in badgedescripcion" :key="index">
                    <th scope="row"> <code>{{badge.propiedad}}</code> </th>
                    <td style="font-size:.7rem;">{{badge.atributo}}</td>
                    <td>{{badge.descripcion}}</td>
                    </tr>
                </tbody>
            </table>




        <!-- datos que se le pasan a la tabla -->
        <!-- <p class="mb-0 mt-3">Ejemplo de datos que se le pasan a la tabla.</p> -->


        <code>
            <span class="d-block mb-3"> <strong>dataRows: </strong><span class="text-dark ms-3">Lista de objetos que se mostraran en la tabla.</span></span>
            <strong>dataColumns:</strong> <span class="text-dark ms-2">Configuración de la columna creada. <br>
            La propiedad</span> type <span class="text-dark">(text, status, o actions. Siendo actions un slot para colocar contenido libre, normalmente es usado para</span> <br>
            <span class="text-dark"> el dropdown de opciones de la fila). <br>
            La propiedad </span>filter <span class="text-dark"> es booleana, define si la columna llevara filtro.</span> <br>
            <span class="text-dark">La propiedad </span>sort <span class="text-dark"> es booleana, define si la columna control que invierte los registros ascendente o descendentes.</span> <br>
            <span class="text-dark">La propiedad </span>rowsFilter <span class="text-dark"> es un array, Almacena los registros que van filtrandose de la columna.</span> <br>
            <span class="text-dark">La propiedad </span>columnName <span class="text-dark">Define el nombre de cabecera de la columna</span> <br>
            <span class="text-dark">La propiedad </span>columnProperty <span class="text-dark">Enlaza la propiedad del nombre de la columna, con el nombre del listado asociado.</span> 
        </code>

        <!-- <h1> colocar la seccion methods</h1> -->



    </section>

    <section class="mt-3 py-3 mb-5">
        <h5 class="text-dark mt-0 mb-3">Ejemplo de tabla personalizada con estados</h5>
        <px-table 
            :dataRows="users" 
            :dataColumns="usersColumns" 
            :selected="userSelect"
            :expand="true"
            :ConfigurationColorStatus="ConfigurationColorStatus"
            status="statusUser"
        >
            <template v-slot:cell="{value,type,property}">
                <template>{{value[property]}}</template>
            </template>
            <template v-slot:expand="{value}">
                <p>id: {{ value.id }}</p>
                <p>Username: {{ value.username }}</p>
            </template>
        </px-table>
        <p>
            Para configurar colores personalizados a cada row, dependiendo de un estatus del registro, se debe añadir 2 propiedades <u>obligatorias</u> a px-table. <br>
            <strong>:ConfigurationColorStatus</strong>, configuración de las clases y valores. <br>
            <strong>status</strong>, nombre del atributo de estado en el objeto.
        </p>
        <div class="mt-4" v-highlight>
                    <pre class="language-html p-0 m-0"><code><script type="text/plain" class="language-markup">
        <px-table 
            :dataRows="users" 
            :dataColumns="usersColumns" 
            :selected="userSelect"
            :expand="true"
            :ConfigurationColorStatus="ConfigurationColorStatus"
            status="statusUser"
        >
            <template v-slot:cell="{value,type,property}">
                <template>{ {value[property]}}</template>
            </template>
            <template v-slot:expand="{value}">
                <!-- aqui su contenido collapsado -->
            </template>
        </px-table>
            </script></code></pre>
        </div>
        <p>
            El nombre del atributo que maneja el estado en este caso es: <u>statusUser</u>. se debe enviar el nombre tal cual, no como una propiedad dinamica, sino como un string. <br>
            El array de configuración <u>ConfigurationColorStatus</u>, sirve para personalizar los colores segun los estados y los valores del estado.
        </p>
        <div v-highlight>
    <pre class="language-javascript p-0"><code>
        users: [
            {
                "id": 1,
                "name": "Leanne Graham",
                "username": "Bret",
                "email": "Sincere@april.biz",
                "website": "hildegard.org",
                "statusUser": 1
            },
            {
                "id": 2,
                "name": "Ervin Howell",
                "username": "Antonette",
                "email": "Shanna@melissa.tv",
                "website": "anastasia.net",
                "statusUser": 2
            }
        ],
        
        ConfigurationColorStatus:[
            { value:1, colorClass:"bg-sucess-sh text-white-sh" },
            { value:2, colorClass:"bg-warning-sh text-gray-medium" },
            { value:3, colorClass:"bg-danger-sh text-white-sh"}
        ]
                </code></pre>
        </div>

    </section>



    </div>
</template>
<script>
    import PxTable from '@/components/table/PxTable.vue'
    import PxBadge from '@/components/badge/PxBadge.vue'
    export default {
        created(){
        // window.scrollTo(0, 0);
        },
        components:{PxTable,PxBadge},
        data: function() {
        return{
            users: [
            {
                "id": 1,
                "name": "Leanne Graham",
                "username": "Bret",
                "email": "Sincere@april.biz",
                "website": "hildegard.org",
                "statusUser": 1
            },
            {
                "id": 2,
                "name": "Ervin Howell",
                "username": "Antonette",
                "email": "Shanna@melissa.tv",
                "website": "anastasia.net",
                "statusUser": 1
            },
            {
                "id": 3,
                "name": "Clementine Bauch",
                "username": "Samantha",
                "email": "Nathan@yesenia.net",
                "website": "ramiro.info",
                "statusUser": 3
            },
            {
                "id": 4,
                "name": "Patricia Lebsack",
                "username": "Karianne",
                "email": "Julianne.OConner@kory.org",
                "website": "kale.biz",
                "statusUser": 1
            },
            {
                "id": 5,
                "name": "Chelsey Dietrich",
                "username": "Kamren",
                "email": "Lucio_Hettinger@annie.ca",
                "website": "demarco.info",
                "statusUser": 2
            }
            ],
            usersColumns:[
                {
                    columnName:"Name",
                    columnProperty:"name",
                    type:"text",
                    filter:false,
                    sort:false,
                    rowsFilter:[]
                },
                {
                    columnName:"Email",
                    columnProperty:"email",
                    type:"text",
                    filter:false,
                    sort:false,
                    rowsFilter:[]
                },
                {
                    columnName:"Website",
                    columnProperty:"website",
                    type:"text",
                    filter:false,
                    sort:false,
                    rowsFilter:[]
                }
            ],
            ConfigurationColorStatus:[
                {
                    value:1,
                    colorClass:"bg-sucess-sh text-white-sh"
                },
                {
                    value:2,
                    colorClass:"bg-warning-sh text-gray-medium"
                },
                {
                    value:3,
                    colorClass:"bg-danger-sh text-white-sh"
                }
            ],
            userSelect:[],


            dataRows: 
                [
                    {
                    "id": 1,
                    "name": "Leanne Graham",
                    "username": "Bret",
                    "email": "Julianne.OConner@kory.org",
                    "website": "hildegard.org",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 2,
                    "name": "Ervin Howell",
                    "username": "Antonette",
                    "email": "Julianne.OConner@kory.org",
                    "website": "anastasia.net",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 3,
                    "name": "Clementine Bauch",
                    "username": "Samantha",
                    "email": "Julianne.OConner@kory.org",
                    "website": "ramiro.info",
                    "idestatus": "1",
                    "desc_estatus":"Activo"
                    },
                    {
                    "id": 4,
                    "name": "Patricia Lebsack",
                    "username": "Karianne",
                    "email": "Julianne.OConner@kory.org",
                    "website": "kale.biz",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 5,
                    "name": "Chelsey Dietrich",
                    "username": "Kamren",
                    "email": "Lucio_Hettinger@annie.ca",
                    "website": "demarco.info",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 6,
                    "name": "Mrs. Dennis Schulist",
                    "username": "Leopoldo_Corkery",
                    "email": "Karley_Dach@jasper.info",
                    "website": "ola.org",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 7,
                    "name": "Kurtis Weissnat",
                    "username": "Elwyn.Skiles",
                    "email": "Telly.Hoeger@billy.biz",
                    "website": "elvis.io",
                    "idestatus": "2",
                    "desc_estatus":"Cancelado"
                    },
                    {
                    "id": 8,
                    "name": "Nicholas Runolfsdottir V",
                    "username": "Maxime_Nienow",
                    "email": "Sherwood@rosamond.me",
                    "website": "jacynthe.com",
                    "idestatus": "3",
                    "desc_estatus":"En proceso"
                    },
                    {
                    "id": 9,
                    "name": "Glenna Reichert",
                    "username": "Delphine",
                    "email": "Chaim_McDermott@dana.io",
                    "website": "conrad.com",
                    "idestatus": "3",
                    "desc_estatus":"En proceso"
                    },
                    {
                    "id": 11,
                    "name": "Clementina DuBuque",
                    "username": "Moriah.Stanton",
                    "email": "Rey.Padberg@karina.biz",
                    "website": "ambrose.net",
                    "idestatus": "3",
                    "desc_estatus":"En proceso"
                    },                                                                                                                                    
            ],
            dataColumns:
            [
                {
                    columnName:"Name",
                    columnProperty:"name",
                    type:"text",
                    filter:true,
                    sort:true,
                    rowsFilter:[]
                },
                {
                    columnName:"Email",
                    columnProperty:"email",
                    filter:true,
                    type:"text",
                    sort:false,
                    rowsFilter:[]
                },
                // {
                //     columnName:"Id",
                //     columnProperty:"id",
                //     filter:true,
                //     type:"number",
                //     sort:false,
                //     rowsFilter:[]
                // },
                {
                    columnName:"Estatus",
                    columnProperty:"desc_estatus",
                    type:"status",
                    filter:false,
                    sort:true,
                    rowsFilter:[]
                },
                {
                    columnName:"Acciones",
                    columnProperty:"",
                    type:"actions",
                    filter:false,
                    sort:false,
                    rowsFilter:[]
                }
            ],
            selected:[],
            
            badgeConfiguration:[
                {
                    value:1,
                    colorClass:"badge bg-sucess-sh text-white-sh"
                },
                {
                    value:2,
                    colorClass:"badge bg-danger-sh text-white-sh"
                },
                {
                    value:3,
                    colorClass:"badge bg-warning-sh text-gray-medium"
                }
            ],
            descripcion: [
                { 'propiedad': ':dataRows', 'atributo': 'Array de objetos', 'descripcion': 'Lista de objetos que se mostraran en la tabla.' },
                { 'propiedad': ':dataColumns', 'atributo': 'Array de objetos', 'descripcion': 'configura el tipo de columna que se creara, si tendra filtros, que tipo de propiedad sera, su estado, texto, o acción (dropdown).' },
                { 'propiedad': ':selected', 'atributo': 'Array', 'descripcion': 'Guarda array con objeto (s), seleccionado de la tabla.' },
                { 'propiedad': ':checkAllRows', 'atributo': 'Boolean', 'descripcion': 'Define si la tabla tendra selección multiple.' },
                { 'propiedad': ':expand', 'atributo': 'Boolean', 'descripcion': 'Define si las filas serán un collapse (arcordeón)' },
                { 'propiedad': ':maxNumber', 'atributo': 'number', 'descripcion': 'Define la cantidad de registros que aparecera en la tabla al iniciar.' },
                { 'propiedad': ':showSearch', 'atributo': 'Boolean', 'descripcion': 'Define si el buscador y el select de numero de registros a mostrar sea visible' },
                { 'propiedad': ':showPagination', 'atributo': 'Boolean', 'descripcion': 'define si la tabla tendra paginado' },
                { 'propiedad': '@table-sort="handleSortTable"', 'atributo': '-', 'descripcion': 'Propiedad obligatoria, para el funcionamiento de la tabla' },
                { 'propiedad': '@select-all="handleSelectAllTable"', 'atributo': '-', 'descripcion': 'Propiedad obligatoria, para el funcionamiento de la tabla' }
            ],
            badgedescripcion: [
                {'propiedad': ':dataConfiguration', 'atributo': 'Array de objetos', 'descripcion': 'Configura los estilos del badge, se pasara un array de objetos con las siguientes propiedades: value: y colorClass. ejemplo: { value:1, colorClass:"badge rounded-pill bg-sucess-sh text-white-sh" } ' },
                { 'propiedad': ':value', 'atributo': 'Variable numerica', 'descripcion': 'Define los estilos que previamente han sido configurados en la propiedad dataConfiguration.' },
                { 'propiedad': ':description', 'atributo': 'string', 'descripcion': 'Leyenda que tendra el badge' }
                
            ],


            //***data de la plantilla***
            // htmlvalue: '<px-table',
            // htmlvalue2: '</px-table>',
            // template1: '<template',
            // template2: '</template>',
            // comentario1: '<!--',
            // comentario2: '-->',
            // htmlbadge: '<px-badge',
            // htmlbadge2: '</px-badge>',
            // div1: '<div',
            // div2: '</div>',
            // boton1: '<button',
            // boton2: '</button>',
            // awesome: '<font-awesome-icon icon="fa-solid fa-gear" class="text-gray-medium" />',
            // ul1: '<ul>',
            // ul2: '</ul>',
            // li1: '<li>',
            // li2: '</li>',
            // llaves1: '{{',
            // llaves2: '}}'


        }

      },
    methods:{
        handleSortTable($event, columnProperty){
            this.dataRows = this.$vs.sortData($event ,this.dataRows , columnProperty)
        },
        handleSelectAllTable(){
            this.selected = this.$vs.checkAll(this.selected, this.dataRows)
        }
    }
    }
</script>
<style scoped>
th { color: black; }
</style>